/**
 * POC demo login: fixed accounts, no Cognito/DB.
 * Keep in sync with api/database seed emails so PHP profile lookup works.
 */

export const DEMO_AUTH_MODE =
  (process.env.REACT_APP_DEMO_AUTH_MODE || '').toLowerCase() === 'true';

export const DEMO_SESSION_KEY = 'mindy_demo_user';

export const DEMO_USERS = [
  {
    email: (process.env.REACT_APP_DEMO_PARENT_EMAIL || 'susan.park@mindyknows.com')
      .trim()
      .toLowerCase(),
    password: process.env.REACT_APP_DEMO_PARENT_PASSWORD || 'Susan123@',
    role: 'parent',
    firstName: 'Susan',
    lastName: 'Park',
    scripts: [
      'mindyKNOW',
      'P1_fin hotel',
      'P2_survival pack',
      'P3_urgent care',
      'P4_grandma soup',
    ],
  },
  {
    email: (process.env.REACT_APP_DEMO_STUDENT_EMAIL || 'maggie.park@mindyknows.com')
      .trim()
      .toLowerCase(),
    password: process.env.REACT_APP_DEMO_STUDENT_PASSWORD || 'Maggie123@',
    role: 'student',
    firstName: 'Maggie',
    lastName: 'Park',
    scripts: ['s1_dorm makeover'],
  },
];

export function createDemoSession(user) {
  return {
    username: user.email,
    role: user.role,
    attributes: {
      email: user.email,
      given_name: user.firstName,
      family_name: user.lastName,
      'custom:given_name': user.firstName,
      'custom:family_name': user.lastName,
      'custom:parentProfile': String(user.role === 'parent'),
      'custom:scripts': user.scripts.join(', '),
    },
  };
}

export function normalizeDemoSession(parsed) {
  const email = (parsed?.username || '').trim().toLowerCase();
  const user = DEMO_USERS.find((u) => u.email === email);
  if (!user) {
    return null;
  }
  return createDemoSession(user);
}

/** Read and migrate legacy sessions missing `attributes`. */
export function readDemoSession() {
  try {
    const raw = localStorage.getItem(DEMO_SESSION_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    const normalized = normalizeDemoSession(parsed);
    if (normalized) {
      localStorage.setItem(DEMO_SESSION_KEY, JSON.stringify(normalized));
      return normalized;
    }
    return null;
  } catch {
    return null;
  }
}
